export default __webpack_public_path__ + "static/media/BoardRoom.0f7f1fef.jpg";